CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Board = require 'models/board'

module.exports = class PublicBoardList extends CollectionWithHelpers
  model: Board



// WEBPACK FOOTER //
// ./app/scripts/models/collections/public-board-list.coffee